import styled from '@emotion/styled'
import { colors } from '../../shared/ui/colors'

export const SidebarContainer = styled.aside<{ $collapsed: boolean }>`
  width: 100%;
  background-color: ${colors.white};
  color: ${colors.gray900};
  padding: 5px;
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.08);
  border: 1px solid ${colors.gray200};
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
  align-items: ${({ $collapsed }) => ($collapsed ? 'center' : 'stretch')};
  transition: align-items 0.2s ease-in-out;
`

export const Logo = styled.div<{ $collapsed: boolean }>`
  padding: 8px ${({ $collapsed }) => ($collapsed ? '8px' : '12px')} 16px
    ${({ $collapsed }) => ($collapsed ? '8px' : '12px')};
  margin-bottom: 12px;
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: ${({ $collapsed }) =>
    $collapsed ? 'center' : 'space-between'};
  gap: 10px;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: ${colors.gray200};
  }
`

export const LogoTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const LogoText = styled.div`
  margin: 0;
  font-size: 22px;
  color: ${colors.orange900};
  font-weight: 600;
  letter-spacing: -0.01em;
`

export const LogoSubtext = styled.div`
  margin: 0;
  font-size: 14px;
  color: ${colors.gray800};
  font-weight: 500;
  line-height: 16px;
`

export const ToggleButton = styled.button<{ $collapsed: boolean }>`
  position: ${({ $collapsed }) => ($collapsed ? 'static' : 'absolute')};
  top: 2px;
  right: 4px;
  width: 32px;
  height: 32px;
  padding: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${colors.gray700};
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
  border: 0;
  background-color: transparent;

  &:hover {
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
  }
`
